import { useState } from 'react'
import logo from '../resources/imgs/cnclogo-white.png'

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => setIsOpen(!isOpen)

  const handleScroll = (e, targetId) => {
    e.preventDefault()
    setIsOpen(false)

    const targetElement = document.querySelector(targetId)
    const navElement = document.querySelector('.navigation') // Zaměříme navbar
    if (!targetElement || !navElement) return

    // Dynamicky zjistíme aktuální výšku navbaru v px
    const navHeight = navElement.offsetHeight

    const isMobile = window.innerWidth <= 950

    if (isMobile) {
      // OKAMŽITÝ SKOK
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.scrollY

      window.scrollTo({
        top: elementPosition - navHeight, // Použijeme dynamickou výšku
        behavior: 'auto',
      })
    } else {
      // PLYNULÝ SCROLL (Lenis)
      if (window.lenis) {
        window.lenis.scrollTo(targetId, {
          offset: -navHeight, // Použijeme dynamickou výšku
          duration: 1.5,
        })
      }
    }
  }

  return (
    <nav className={`navigation ${isOpen ? 'nav-open' : ''}`}>
      <img
        src={logo}
        alt='CNC Duben'
        onClick={e => handleScroll(e, '#home')}
        className='navigation-logo'
      />

      {/* Hamburger ikona */}
      <div className='navigation-hamburger' onClick={toggleMenu}>
        <span className='navigation-hamburger-bar'></span>
        <span className='navigation-hamburger-bar'></span>
        <span className='navigation-hamburger-bar'></span>
      </div>

      <ul
        className={`navigation-menu ${isOpen ? 'navigation-menu--open' : ''}`}
      >
        <li>
          <a
            href='#home'
            onClick={e => handleScroll(e, '#home')}
            className='navigation-item'
          >
            Úvod
          </a>
        </li>
        <li>
          <a
            href='#about'
            onClick={e => handleScroll(e, '#hero')}
            className='navigation-item'
          >
            O společnosti
          </a>
        </li>
        <li>
          <a
            href='#equipment'
            onClick={e => handleScroll(e, '#equipment')}
            className='navigation-item'
          >
            Výrobní možnosti
          </a>
        </li>
        <li>
          <a
            href='#contact'
            onClick={e => handleScroll(e, '#contact')}
            className='navigation-item'
          >
            Kontakty
          </a>
        </li>
      </ul>

      {/* <select className='navigation-select' name='langugage' id=''>
        <option>Česky</option>
        <option>English</option>
        <option>Deutsch</option>
      </select>*/}
    </nav>
  )
}

export default Navigation
